<template>
  <el-dialog
    class="init-config-wizard"
    top="8vh"
    :visible.sync="dialog_visible"
    :fullscreen="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    :center="true"
    :title="step == 1 ? 'Welcome to Goalpilot' : ''"
    @close="onResetForm">

    <div v-if="step === 1">
      <div style="height: 400px;" class="center-container">
        <span style="font-size: 200%">Hello!<br /><br />Welcome aboard</span>
      </div>
    </div>

    <div v-if="step === 2">
      <h1>What are your goals?</h1>
      <div class="button-container">

        <el-checkbox
          v-for="goal in abstract_goals"
          :key="goal.id"
          v-model="goal.checked"
          border
          class="fat-checkbox">
          <img class="fat-checkbox__image" :src="goal.src" />
          <div class="fat-checkbox__text">{{goal.text}}</div>
        </el-checkbox>

        <!--
        <el-checkbox v-model="goals[0]" border class="fat-checkbox">
          <img class="fat-checkbox__image" src="@/assets/flaticons/autobot.svg" />
          <div class="fat-checkbox__text">Get shit done.</div>
        </el-checkbox>
        <el-checkbox v-model="goals[1]" border class="fat-checkbox">
          <img class="fat-checkbox__image" src="@/assets/flaticons/hydra.svg" />
          <div class="fat-checkbox__text">Tame the multitasking hydra.</div>
        </el-checkbox>
        <el-checkbox v-model="goals[2]" border class="fat-checkbox">
          <img class="fat-checkbox__image" src="@/assets/flaticons/woman.svg" />
          <div class="fat-checkbox__text">Get kick-ass habits and become fit as f*ck.</div>
        </el-checkbox>
        <el-checkbox v-model="goals[3]" border class="fat-checkbox">
          <img class="fat-checkbox__image" src="@/assets/flaticons/rocket.svg" />
          <div class="fat-checkbox__text">Be hyper productive.</div>
        </el-checkbox>
        -->
      <span>You'll be able to change these setting later.</span>
      </div>
    </div>

    <div v-if="step === 3">
      <h1>When do you usually wake up?</h1>
      <img src="@/assets/flaticons/alarm-clock.svg" style="margin: 4em auto; display: block;" />
      <vue-time-picker v-model="wake_up_time" format="HH:mm" :minute-interval="5" />
      <!-- TODO: Why not el-time-picker -->
      <!-- el-time-picker has scroll to view! -->
      <!-- {{wake_up_time}} | {{wakeUpTimeNumeric}} -->
    </div>

    <div v-if="step === 4">
      <h1>How does your ideal day look like?</h1>
      <p style="text-align: justify; width: 400px; margin: 1em auto; word-break: break-word;">
        <!-- TODO: EXMPLAIN WHY, TODO: Allow to not select a plan -->
      </p>
      <div style="display: flex; justify-content: space-between;">
        <dayplan-preview :plan="plan_templates[0]" :plan-id="1" @select="onSelectPlan" :selected="selected_plan === 1" />
        <dayplan-preview :plan="plan_templates[1]" :plan-id="2" @select="onSelectPlan" :selected="selected_plan === 2" />
        <dayplan-preview :plan="plan_templates[2]" :plan-id="3" @select="onSelectPlan" :selected="selected_plan === 3" />
      </div>
      <span>Plans can always be customized later on.</span>
      <span style="float: right;">
        <a href="#" @click.prevent="onShowMorePlanOptions">show more options</a>
      </span>
    </div>

    <div v-if="step === 5">
      <h1>Tell us more about your day!</h1>
      <div style="display: flex; justify-content: center;">
        <dayplan-preview :plan="user_plan" :plan-id="selected_plan" :show-time="true" />
      </div>
      <h4 class="mt-3">Click on a time to change it</h4>
    </div>

    <div v-if="step === 6">
      <h1>Please connect your calender</h1>
      <p style="text-align: justify; width: 400px; margin: 1em auto; word-break: break-word;">
        You've selected work. Do you have a work calendar with existing meetings?
        Goalpilot can automatically import existing events and takes them into
        account when planning new things.
      </p>
      <div style="display: flex; justify-content: space-evenly;" class="mt-6 mb-8">
        <div style="display: flex; flex-direction: column;">
          <img style="display: block; margin: 1em auto;" src="@/assets/flaticons/mac-calendar.png" />
          <el-button type="primary" round plain disabled>Connect iOS Calendar</el-button>

          <el-alert title="Info" type="warning" class="mt-2" :closable="false">iOS Calendar is currently not available.</el-alert>
        </div>
        <div style="display: flex; flex-direction: column;">
          <img style="display: block; margin: 1em auto;" src="@/assets/flaticons/google-calendar.png" />
          <el-button v-if="google_calendar_authorized !== 1" type="primary" round plain @click="onConnectCalendar('google')">Connect Google Calendar</el-button>
          <span v-if="google_calendar_authorized === 1">Google Calendar is connected</span>
          <!-- <span v-if="google_calendar_authorized === -1">Connection failed</span> -->
        </div>
      </div>

    </div>

    <div v-if="step === 7">
      <div style="height: 400px;" class="center-container">
        <span style="font-size: 200%">Awesome!<br /><br />Thank you!</span>
      </div>
      <!--
<pre>
wake_up_time: {{wake_up_time}}
abstract_goals: {{abstract_goals}}
selected_plan: {{selected_plan}}
user_plan: {{user_plan}}
</pre>
    -->
    </div>

    <!--
    <el-steps :active="step" align-center class="my-6">
      <el-step title="Step 1"></el-step>
      <el-step title="Step 2"></el-step>
      <el-step title="Step 3"></el-step>
      <el-step title="Step 4"></el-step>
      <el-step title="Step 5"></el-step>
      <el-step title="Step 6"></el-step>
      <el-step title="Step 7"></el-step>
    </el-steps>
    -->

    <div class="wizard-buttons pt-2">
      <el-button v-if="step > 1" @click="onClickBack">Go back</el-button>
      <el-button v-if="step < 7" @click="onClickNext" :disabled="disableNext">Next</el-button>
      <el-button v-if="step === 7" @click="onClickDone">Done</el-button>
    </div>

  </el-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import clonedeep from 'lodash.clonedeep'
import moment from '@/moment-gp'

const ABSTRACT_GOALS = [
  {
    id: "get_things_done",
    src: require("@/assets/flaticons/autobot.svg"),
    text: "Get shit done.",
    checked: false
  },
  {
    id: "multitasking",
    src: require("@/assets/flaticons/hydra.svg"),
    text: "Tame the multitasking hydra.",
    checked: false
  },
  {
    id: "habits",
    src: require("@/assets/flaticons/woman.svg"),
    text: "Get kick-ass habits.",
    checked: false
  },
  {
    id: "productivity",
    src: require("@/assets/flaticons/rocket.svg"),
    text: "Be hyper productive.",
    checked: false
  },
]

// TODO: Store category key in DB

const PLAN1 = [
  { label: 'Morning routine', from: 7, to: 9, category_key: 'morning' },
  { label: 'Work', from: 9, to: 17, category_key: 'work' },
  { label: 'Leisure time', from: 17, to: 22, category_key: 'leisure' },
]

const PLAN2 = [
  { label: 'Morning routine', from: 7, to: 9 , category_key: 'morning' },
  { label: 'Work', from: 9, to: 17, category_key: 'work' },
  { label: 'Sports', from: 17, to: 19, category_key: 'sport' },
  { label: 'Leisure time', from: 19, to: 22, category_key: 'leisure' },
]

const PLAN3 = [
  { label: 'Morning routine', from: 7, to: 8, category_key: 'morning' },
  { label: 'Sports', from: 8, to: 9, category_key: 'sport' },
  { label: 'Work', from: 9, to: 17, category_key: 'work' },
  { label: 'Leisure time', from: 17, to: 22, category_key: 'leisure' },
]

const TSC_COLOR_MAP = {
  morning: '#F9AE00',
  work:    '#17ABE3',
  leisure: '#69B42D',
  sport:   '#E74310',
}

export default {
  data: () => ({
    dialog_visible: false,
    step: 1,
    wake_up_time: {
      HH: "07",
      mm: "00",
    },
    abstract_goals: ABSTRACT_GOALS,
    plan_templates: [ PLAN1, PLAN2, PLAN3 ],
    selected_plan: 0,
    user_plan: [],
  }),
  computed: {
    ...mapGetters("calendar", [
      "google_calendar_authorized",
    ]),

    disableNext() {
      if ( this.step === 3 && this.wake_up_time === null ) {
        return true
      }
      if ( this.step === 4 && !this.selected_plan ) {
        return true
      }
      return false;
    },

    wakeUpTimeNumeric() {
      let t = this.wake_up_time
      return moment.convertHHmmToFractional( t.HH + ':' + t.mm )
    }
  },
  methods: {
    ...mapActions("calendar", [
      "google_calendar_auth",
    ]),

    onSelectPlan( selected_plan ) {
      this.selected_plan = selected_plan
      this.user_plan = clonedeep( this.plan_templates[ selected_plan - 1 ] )

      // TODO: This won't work in many cases

      let default_from = this.user_plan[0].from;
      let delta        = this.wakeUpTimeNumeric - default_from;
      let sleep_time   = ( 24 + ( this.wakeUpTimeNumeric - 8 ) ); // % 24;

      this.user_plan = this.user_plan.map(item => {
        return {
          label:        item.label,
          category_key: item.category_key,
          from:         item.from + delta,
          to:           item.to + delta
        }
      })

      this.user_plan[0].from = this.wakeUpTimeNumeric;

      this.user_plan.push({
        label:        'Sleep',
        category_key: 'ignore',
        from:         sleep_time,
        to:           sleep_time + 1
      })

      console.log("Userplan", JSON.stringify(this.user_plan, ' ', 2), "delta", delta)
    },

    showNewModal() {
      this.dialog_visible = true;
    },

    showUpdateModal() {
      this.dialog_visible = true;
    },

    onResetForm() {
      this.dialog_visible = false;
    },

    onClickNext() {
      if ( this.step === 1 ) { // HACK: skip step 2
        this.step = 3;
        return
      }
      if ( this.step < 7 ) {
        this.step += 1;
      }
    },

    onClickBack() {
      if ( this.step === 3 ) { // HACK: skip step 2
        this.step = 1;
        return
      }
      if ( this.step > 1 ) {
        this.step -= 1;
      }
    },

    onClickDone() {

      /* Create timeslot collections and rules from user input */
      let plan = this.user_plan.map(item => {
        if ( item.category_key === 'ignore' ) {
          return null
        }

        // TODO: Set leisure start time = sport start time
        // TODO: This won't work with

        let mapped_item = {
          name:  item.label,
          color: TSC_COLOR_MAP[ item.category_key ],
          key:   item.category_key,
          rules: [{
            weekdays: 'xxxxx--',
            from:     moment.convertFractionalToHHmm( item.from ),
            to:       moment.convertFractionalToHHmm( item.to ),
          }]
        }

        // TODO: Confirm this via UI
        // TODO: Include mornign routine and sport?

        if ( item.category_key === 'morning' ) {
          mapped_item.rules.push({
            weekdays: '-----xx',
            from:     '6:00',
            to:       '12:00'
          })
        }
        if ( item.category_key === 'leisure' ) {
          mapped_item.rules.push({
            weekdays: '-----xx',
            from:     '8:00',
            to:       '22:00'
          })
        }

        return mapped_item
      }).filter(item => item)

      console.log("plan", plan)

      let p1 = this.$api.timeslot_collection_create_from_array( plan );

      /* Save abstract goal settings to DB */
      let abstract_goal_settings =
        this.abstract_goals
        .filter(goal => goal.checked)
        .map(goal => goal.id)

      console.log("abstract_goal_settings", abstract_goal_settings)

      /* also set onboarding switch to false  */
      let p2 = this.$models.userSettings.update( this.$models.user.defaultUserId, {
        abstractGoalSettings: abstract_goal_settings.join(','),
        showOnboarding: false
      })

      this.dialog_visible = false;
      // this.step = 1;

      Promise.all([p1, p2]).then(() => {
        // HACK! Reload page
        this.$router.go()
      })
    },

    onShowMorePlanOptions() {
      // TODO: Send info to tracker
    },

    onConnectCalendar(type) {
      switch ( type ) {
        case 'google':
          this.google_calendar_auth(true);
        break;

        // case 'apple': break;
        default: throw new Error('unknow type: ' + type)
      }
    },
  },
}
</script>

<style>
.init-config-wizard .el-dialog {
  /* min-width: 600px;
  max-width: 800px; */
}
.init-config-wizard .wizard-buttons {
  margin-top: 1em;
  display: flex;
  justify-content: flex-end;
}
.init-config-wizard .button-container {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  padding: 0 3em;
}
.init-config-wizard .el-checkbox.is-bordered {
  border: 2px solid black;
  width: 220px;
  height: 220px;
  display: block;
  flex: 0 0 220px;
  padding: 10px;
  margin: 1em !important;
}
.init-config-wizard h1,
.init-config-wizard h4 {
  text-align: center;
}
.init-config-wizard .time-picker {
  display: block;
  margin: 0 auto;
  font-size: 150%;
}
</style>
